<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template #activator="{ on }">
      <v-text-field
        v-if="!showSwatches"
        v-model="color"
        class="pt-0"
        :error-messages="errors"
        :disabled="disabled"
        :label="label"
        readonly
        v-bind="$attrs"
        v-on="on"
      >
        <template #prepend>
          <v-icon
            :disabled="disabled"
            :color="color"
            v-on="on"
          >
            mdi-circle
          </v-icon>
        </template>
      </v-text-field>
      <v-text-field
        v-else-if="showSwatches && label"
        v-model="color"
        class="pt-0 fullsize-swatch-input"
        :error-messages="errors"
        :disabled="disabled"
        :label="label"
        readonly
        v-bind="$attrs"
        v-on="on"
      >
        <template #append>
          <div
            :style="`height: 18px; background-color: ${color}; border-radius: 4px`"
            class="w-100 mt-1 mx-1 cursor-pointer"
            v-on="on"
          >
            &nbsp;
          </div>
        </template>
        <template #append-outer>
          <v-icon v-on="on">
            mdi-menu-down
          </v-icon>
        </template>
      </v-text-field>
      <v-icon
        v-else
        :disabled="disabled"
        :color="color"
        v-on="on"
      >
        mdi-circle
      </v-icon>
    </template>
    <v-sheet>
      <v-color-picker
        v-model="color"
        :class="showSwatches ? 'no-slider' : ''"
        type="hex"
        mode="hexa"
        :hide-canvas="showSwatches"
        :hide-inputs="showSwatches"
        :show-swatches="showSwatches"
        :swatches="swatches"
        swatches-max-height="300"
        flat
        @input="updateValue"
      />
      <v-btn
        text
        class="mt-0"
        color="primary"
        block
        @click="menu = false"
      >
        {{ $t('button.close') }}
      </v-btn>
    </v-sheet>
  </v-menu>
</template>

<script lang="ts" setup>
import { PropType, ref, watch } from 'vue';
import { TranslateResult } from 'vue-i18n';

const emit = defineEmits<{(e: 'input', event: string): void}>();

const props = defineProps({
  value: { type: String, required: true },
  disabled: { type: Boolean, required: false, default: false },
  label: { type: [String, Object] as PropType<string|TranslateResult>, required: false, default: '' },
  showSwatches: { type: Boolean, required: false, default: false },
  swatches: { type: Array, required: false, default: () => [] as Array<String> },
  errors: { type: Array, required: false, default: undefined },
});

const color = ref(props.value);

watch(() => props.value, () => { color.value = props.value; });

const menu = ref(false);

const updateValue = () => {
  if (props.showSwatches) {
    menu.value = false;
  }
  emit('input', color.value);
};
</script>

<style lang="scss" scoped>

.no-slider ::v-deep(.v-color-picker__controls) {
    display: none;
}

.fullsize-swatch-input ::v-deep(.v-text-field__slot), .fullsize-swatch-input ::v-deep(.v-text-field__slot label)  {
  overflow: visible;
}

.fullsize-swatch-input ::v-deep(.v-text-field__slot input) {
  visibility: hidden;
  width: 0px;
}

.fullsize-swatch-input ::v-deep(.v-input__append-inner) {
  width: 100%;
}

</style>
